// Case prioritások — sorrend a legmagasabbtól a legalacsonyabbig megjelenítéshez
export const PRIORITIES = ['urgent', 'high', 'normal', 'low'];

// i18n kulcs: t(`priority.${p}`)
export const priorityKey = (p) => `priority.${p}`;

// CSS chip osztály: pr-urgent, pr-high, ...
export const priorityChip = (p) => `cs-chip pr-${p || 'normal'}`;
